/* eslint-disable */
/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of Crowdtech::Application.
 * @version c9c10a63b95f7290454c02ec04890bb600ada040ca59e6055cb257ae57c4f41c
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /about(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const about_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/techdirect_registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_techdirect_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"techdirect_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_path = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agree_accept_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agree_accept_terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agree_accept_terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/clients/inquiries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_inquiries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"inquiries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/cloudsign/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_cloudsign_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"cloudsign"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/auths(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_auths_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"auths"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/contract_extension_requests/:access_token(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_contract_extension_request_path = /*#__PURE__*/ __route({"access_token":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"contract_extension_requests"],[2,[7,"/"],[2,[3,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/monthly_work_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_monthly_work_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/monthly_work_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_monthly_work_reports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/questionnaires(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_questionnaires_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"questionnaires"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/questionnaires/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_questionnaires_count_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/questionnaires/years(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_questionnaires_years_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[6,"years"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/staffs/:staff_token/password(.:format)
 * @param {any} staff_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_staff_password_path = /*#__PURE__*/ __route({"staff_token":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"staffs"],[2,[7,"/"],[2,[3,"staff_token"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/staff/verify_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_staff_verify_email_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"verify_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clients/staffs/:staff_token/verify_token(.:format)
 * @param {any} staff_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_clients_staff_verify_token_path = /*#__PURE__*/ __route({"staff_token":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"staffs"],[2,[7,"/"],[2,[3,"staff_token"],[2,[7,"/"],[2,[6,"verify_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_auth_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/evaluations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_evaluations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/identify_verification_address(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_identify_verification_address_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"identify_verification_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/invoice_informations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_invoice_informations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invoice_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/invoice_numbers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_invoice_numbers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invoice_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/:job_offer_id/application(.:format)
 * @param {any} job_offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offer_application_path = /*#__PURE__*/ __route({"job_offer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[3,"job_offer_id"],[2,[7,"/"],[2,[6,"application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offer_categories/occupations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offer_categories_occupations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offer_categories"],[2,[7,"/"],[2,[6,"occupations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/:job_offer_id/detail(.:format)
 * @param {any} job_offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offer_detail_path = /*#__PURE__*/ __route({"job_offer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[3,"job_offer_id"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offer_summary/:job_offer_id(.:format)
 * @param {any} job_offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offer_summary_path = /*#__PURE__*/ __route({"job_offer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offer_summary"],[2,[7,"/"],[2,[3,"job_offer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/appeals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_appeals_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"appeals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_categories_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_count_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/favorites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_favorite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"favorites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/recommended_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_recommended_categories_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"recommended_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/recommended_skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_recommended_skills_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"recommended_skills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/seo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_seo_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"seo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/job_offers/skill_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_job_offers_skill_categories_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"skill_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_logout_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_password_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/password_reset_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_password_reset_request_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_reset_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/password_reset_request/verify_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_password_reset_request_verify_token_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_reset_request"],[2,[7,"/"],[2,[6,"verify_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/prefectures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_prefectures_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"prefectures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_profile_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/recommended_job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_recommended_job_offers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"recommended_job_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/referral_tokens/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_referral_token_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"referral_tokens"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_referrals_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/related_job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_related_job_offers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"related_job_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/searching_bookmarks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_searching_bookmarks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"searching_bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/searching_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_searching_histories_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"searching_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/todo_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_todo_list_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"todo_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/top/featured_job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_top_featured_job_offers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"top"],[2,[7,"/"],[2,[6,"featured_job_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/top/information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_top_information_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"top"],[2,[7,"/"],[2,[6,"information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/top/job_offer_search/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_top_job_offer_search_categories_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"top"],[2,[7,"/"],[2,[6,"job_offer_search"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/top/job_offer_search/master_skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_top_job_offer_search_master_skills_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"top"],[2,[7,"/"],[2,[6,"job_offer_search"],[2,[7,"/"],[2,[6,"master_skills"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/user/referral_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_user_referral_token_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"referral_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/user_skill_relations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_user_skill_relations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"user_skill_relations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/work_preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_work_preference_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"work_preference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/:id/application_completed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const application_completed_job_offer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"application_completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bank_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bank_account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bank_account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bank_branches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bank_branch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bank_branches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /banks/:bank_id/branches(.:format)
 * @param {any} bank_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bank_branches_path = /*#__PURE__*/ __route({"bank_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"banks"],[2,[7,"/"],[2,[3,"bank_id"],[2,[7,"/"],[2,[6,"branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_accounting_support_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_accounting_support_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/money_forward_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_accounting_support_money_forward_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"money_forward_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/money_forward_user/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_accounting_support_money_forward_user_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"money_forward_user"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/benefit_one_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_benefit_one_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"benefit_one_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_healthcare_support_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/first_call_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_healthcare_support_first_call_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"first_call_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/first_call_user/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_healthcare_support_first_call_user_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"first_call_user"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_healthcare_support_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /benefit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benefit_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /career_supporters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const career_supporter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"career_supporters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /career_supporters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const career_supporters_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"career_supporters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /client_app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_app_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"client_app"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /client_contract_feedback_requests/:access_token(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_contract_feedback_request_path = /*#__PURE__*/ __route({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"client_contract_feedback_requests"],[2,[7,"/"],[2,[3,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contract_extension_requests/:access_token(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contract_extension_request_path = /*#__PURE__*/ __route({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contract_extension_requests"],[2,[7,"/"],[2,[3,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crowdworks_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crowdworks_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crowdworks_session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customer_testimonials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_testimonial_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_testimonials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_testimonials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_testimonials_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_testimonials"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/techdirect_registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_techdirect_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"techdirect_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/techdirect_registration_completed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_techdirect_registration_completed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"techdirect_registration_completed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /design_guideline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_guideline_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"design_guideline"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /design_guideline/column(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_guideline_column_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"design_guideline"],[2,[7,"/"],[2,[6,"column"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /design_guideline/grid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_guideline_grid_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"design_guideline"],[2,[7,"/"],[2,[6,"grid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /design_guideline/spacing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_guideline_spacing_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"design_guideline"],[2,[7,"/"],[2,[6,"spacing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /done_identify_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const done_identify_verification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"done_identify_verification"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_benefit_accounting_support_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/money_forward_user/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_benefit_accounting_support_money_forward_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"money_forward_user"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/money_forward_user/complete/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_benefit_accounting_support_money_forward_user_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"money_forward_user"],[2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_benefit_healthcare_support_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/first_call_user/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_benefit_healthcare_support_first_call_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"first_call_user"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/first_call_user/complete/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_benefit_healthcare_support_first_call_user_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"first_call_user"],[2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /career_supporters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_career_supporter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"career_supporters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_testimonials/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_customer_testimonial_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_testimonials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /embex_education/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_embex_education_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"embex_education"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_area_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/chubu/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_areas_chubue_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"chubu"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kansai/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_areas_kansai_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kansai"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kyushu/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_areas_kyushu_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kyushu"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/beginner/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_beginner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"beginner"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/game/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_game_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"game"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/high_price/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_job_offers_high_price_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"high_price"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/client/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lp_client_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"client"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/client/interview_atrae/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lp_client_interview_atrae_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"client"],[2,[7,"/"],[2,[6,"interview_atrae"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/in_house_editor/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lp_in_house_editor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"in_house_editor"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/listing_ads/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lp_listing_ads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"listing_ads"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/member_contract/contact/edit(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_project_member_contract_contact_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"member_contract"],[2,[7,"/"],[2,[6,"contact"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embex_education(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embex_education_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"embex_education"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /faq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /favorite_job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favorite_job_offers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"favorite_job_offers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /favorite_job_offers/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favorite_job_offers_bulk_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"favorite_job_offers"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"guide"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /healthcheck(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /identify_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identify_verification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"identify_verification"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /information/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const information_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"information"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /information/categories/:category(.:format)
 * @param {any} category
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const information_categories_path = /*#__PURE__*/ __route({"category":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"information"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const information_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"information"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /inquiry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inquiry_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inquiry"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /inquiry/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inquiry_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inquiry"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/:job_offer_id/favorite(.:format)
 * @param {any} job_offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offer_favorite_path = /*#__PURE__*/ __route({"job_offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[3,"job_offer_id"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /job_offers/application_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_application_histories_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"application_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_area_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/chubu/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_chubue_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"chubu"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/chubu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_chubues_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"chubu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kansai/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_kansai_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kansai"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kansai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_kansais_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kansai"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kyushu/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_kyushu_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kyushu"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kyushu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_areas_kyushus_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kyushu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/beginner/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_beginner_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"beginner"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/beginner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_beginners_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"beginner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/features/:path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_feature_path = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_features_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_feed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/game/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_game_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"game"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/game(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_games_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"game"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/high_price/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_high_price_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"high_price"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/high_price(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_high_prices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"high_price"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/indeed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_indeed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"indeed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/6(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_o_6_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[6,"6"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/9(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_o_9_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[6,"9"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/:category_id(.:format)
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_occupation_path = /*#__PURE__*/ __route({"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"category_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/:category_id/a/:appeal_id(.:format)
 * @param {any} category_id
 * @param {any} appeal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_occupation_appeal_path = /*#__PURE__*/ __route({"category_id":{"r":true},"appeal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"appeal_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/:category_id/p/:prefecture_id(.:format)
 * @param {any} category_id
 * @param {any} prefecture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_occupation_prefecture_path = /*#__PURE__*/ __route({"category_id":{"r":true},"prefecture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"prefecture_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/:category_id/s/:skill_id(.:format)
 * @param {any} category_id
 * @param {any} skill_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_occupation_skill_path = /*#__PURE__*/ __route({"category_id":{"r":true},"skill_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"skill_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/:category_id/ws/:work_style_id(.:format)
 * @param {any} category_id
 * @param {any} work_style_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_occupation_work_style_path = /*#__PURE__*/ __route({"category_id":{"r":true},"work_style_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"ws"],[2,[7,"/"],[2,[3,"work_style_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/o/:category_id/wd/:working_day_id(.:format)
 * @param {any} category_id
 * @param {any} working_day_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_occupation_working_day_path = /*#__PURE__*/ __route({"category_id":{"r":true},"working_day_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"wd"],[2,[7,"/"],[2,[3,"working_day_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/p/:prefecture_id(.:format)
 * @param {any} prefecture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_prefecture_path = /*#__PURE__*/ __route({"prefecture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"prefecture_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/remote(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_remotes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"remote"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/searching_bookmark(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_searching_bookmark_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"searching_bookmark"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/s/:skill_id(.:format)
 * @param {any} skill_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_skill_path = /*#__PURE__*/ __route({"skill_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"skill_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/s/:skill_id/a/:appeal_id(.:format)
 * @param {any} skill_id
 * @param {any} appeal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_skill_appeal_path = /*#__PURE__*/ __route({"skill_id":{"r":true},"appeal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"skill_id"],[2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"appeal_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/s/:skill_id/p/:prefecture_id(.:format)
 * @param {any} skill_id
 * @param {any} prefecture_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_skill_prefecture_path = /*#__PURE__*/ __route({"skill_id":{"r":true},"prefecture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"skill_id"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"prefecture_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/s/:skill_id/ws/:work_style_id(.:format)
 * @param {any} skill_id
 * @param {any} work_style_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_skill_work_style_path = /*#__PURE__*/ __route({"skill_id":{"r":true},"work_style_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"skill_id"],[2,[7,"/"],[2,[6,"ws"],[2,[7,"/"],[2,[3,"work_style_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/s/:skill_id/wd/:working_day_id(.:format)
 * @param {any} skill_id
 * @param {any} working_day_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_offers_skill_working_day_path = /*#__PURE__*/ __route({"skill_id":{"r":true},"working_day_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"skill_id"],[2,[7,"/"],[2,[6,"wd"],[2,[7,"/"],[2,[3,"working_day_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /knowledge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const knowledge_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"knowledge"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lp/client(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_client_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"client"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/client/interview_atrae(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_client_interview_atrae_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"client"],[2,[7,"/"],[2,[6,"interview_atrae"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/facebook_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_facebook_auth_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"facebook_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/fukuoka(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_fukuoka_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"fukuoka"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/in_house_designer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_in_house_designer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"in_house_designer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/in_house_designer/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_in_house_designer_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"in_house_designer"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/in_house_editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_in_house_editor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"in_house_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/listing_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_listing_ads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"listing_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_age(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_age_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_age"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_cw(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_cw_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_cw"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_fb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_fb_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_fb"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_focusskill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_focusskill_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_focusskill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_solo1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_solo1_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_solo1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_solo2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_solo2_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_solo2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_sp1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_sp1_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_sp1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_sp2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_sp2_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_sp2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_sp3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_sp3_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_sp3"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_sp4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_sp4_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_sp4"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/engineer_sp5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_engineer_sp5_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"engineer_sp5"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/focus_sp2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_focus_sp2_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"focus_sp2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/focus_sp4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_focus_sp4_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"focus_sp4"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/highclass(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_highclass_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"highclass"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/temporary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lp_member_temporary_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"temporary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/member/temporary/margin_rule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const margin_rule_lp_member_temporary_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"member"],[2,[7,"/"],[2,[6,"temporary"],[2,[7,"/"],[2,[6,"margin_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /member_contract_feedback_requests/:access_token(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_contract_feedback_request_path = /*#__PURE__*/ __route({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"member_contract_feedback_requests"],[2,[7,"/"],[2,[3,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /member_inquiry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_inquiry_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"member_inquiry"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_accounting_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/money_forward_user/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_accounting_support_money_forward_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"money_forward_user"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/accounting_support/money_forward_user/complete/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_accounting_support_money_forward_user_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"accounting_support"],[2,[7,"/"],[2,[6,"money_forward_user"],[2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/benefit_one_user/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_benefit_one_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"benefit_one_user"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_healthcare_support_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/first_call_user/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_healthcare_support_first_call_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"first_call_user"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benefit/healthcare_support/first_call_user/complete/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_benefit_healthcare_support_first_call_user_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"benefit"],[2,[7,"/"],[2,[6,"healthcare_support"],[2,[7,"/"],[2,[6,"first_call_user"],[2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /career_supporters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_career_supporter_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"career_supporters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_testimonials/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_customer_testimonial_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_testimonials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /embex_education/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_embex_education_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"embex_education"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /inquiry/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_inquiry_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inquiry"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_area_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/chubu/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_areas_chubue_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"chubu"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kansai/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_areas_kansai_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kansai"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/area/kyushu/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_areas_kyushu_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[6,"kyushu"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/beginner/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_beginner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"beginner"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/game/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_game_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"game"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_offers/high_price/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_job_offers_high_price_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"job_offers"],[2,[7,"/"],[2,[6,"high_price"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/client/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lp_client_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"client"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/client/interview_atrae/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lp_client_interview_atrae_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"client"],[2,[7,"/"],[2,[6,"interview_atrae"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/in_house_editor/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lp_in_house_editor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"in_house_editor"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/listing_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lp_listing_ads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"listing_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /password_reset_request/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_password_reset_request_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"password_reset_request"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/member_contract/confirmation/new(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_project_member_contract_confirmation_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"member_contract"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/external/new(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_project_monthly_work_report_external_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_sns_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:notification_id/confirmation(.:format)
 * @param {any} notification_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_confirmation_path = /*#__PURE__*/ __route({"notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"notification_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /observance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observance_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"observance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /password_reset_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_reset_request_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"password_reset_request"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /password_reset_request/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_reset_request_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"password_reset_request"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /professional(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"professional"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /professional/surveys/:access_token(.:format)
 * @param {any} access_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_survey_path = /*#__PURE__*/ __route({"access_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"professional"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional/surveys/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_surveys_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"professional"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/basic_profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_basic_profile_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"basic_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_confirmation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/information_disclosure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_information_disclosure_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"information_disclosure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/skill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_language_and_framework_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"skill"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_resume_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/resume/attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_resume_attachment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"resume"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/resume_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_resume_file_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"resume_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/resume_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_resume_files_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"resume_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sheet/self_appeal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sheet_self_appeal_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"profile_sheet"],[2,[7,"/"],[2,[6,"self_appeal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/member_contract(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_member_contract_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"member_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/member_contract/confirmation(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_member_contract_confirmation_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"member_contract"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/member_contract/contact(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_member_contract_contact_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"member_contract"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/member_contract/security_pledge(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_member_contract_security_pledge_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"member_contract"],[2,[7,"/"],[2,[6,"security_pledge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:month(.:format)
 * @param {any} project_id
 * @param {any} month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_path = /*#__PURE__*/ __route({"project_id":{"r":true},"month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"month"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/acceptance(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_acceptance_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/:day(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {any} day
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_daily_work_report_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"day":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[3,"day"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/expense(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_expense_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"expense"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/expense/details/:detail_id/attachment(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {any} detail_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_expense_detail_attachment_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"detail_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"expense"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[3,"detail_id"],[2,[7,"/"],[2,[6,"attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/external(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_external_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"external"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/external/document(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_external_document_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports/:monthly_work_report_month/start_work(.:format)
 * @param {any} project_id
 * @param {any} monthly_work_report_month
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_report_start_work_path = /*#__PURE__*/ __route({"project_id":{"r":true},"monthly_work_report_month":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[2,[7,"/"],[2,[3,"monthly_work_report_month"],[2,[7,"/"],[2,[6,"start_work"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/monthly_work_reports(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_monthly_work_reports_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"monthly_work_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recommended_job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recommended_job_offers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recommended_job_offers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referral_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"referral"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /searching_bookmarks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searching_bookmark_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"searching_bookmarks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /searching_bookmarks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searching_bookmarks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"searching_bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /searching_histories/:searching_history_id/searching_bookmark(.:format)
 * @param {any} searching_history_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searching_history_searching_bookmark_path = /*#__PURE__*/ __route({"searching_history_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"searching_histories"],[2,[7,"/"],[2,[3,"searching_history_id"],[2,[7,"/"],[2,[6,"searching_bookmark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session_storages/searching_bookmarks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_storages_searching_bookmark_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session_storages"],[2,[7,"/"],[2,[6,"searching_bookmarks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session_storages/searching_bookmarks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_storages_searching_bookmarks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_storages"],[2,[7,"/"],[2,[6,"searching_bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /signup_referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signup_referral_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signup_referral"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signup_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sitemap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_profile_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/registration/finish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_finish_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/registration/recommended_job_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_recommended_job_offers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"recommended_job_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/registration/work_preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_work_preference_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"work_preference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /withdrawal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const withdrawal_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"withdrawal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /withdrawal/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const withdrawal_complete_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"withdrawal"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

